<div class="gray-bg-rounded">
  <div class="today-task">
    <p-accordion value="0">
      <p-accordion-panel value="0">
        <p-accordion-header>
          <div class="d-flex justify-content-between topboder">
            <span class="d-flex justify-content-between gap-2 align-items-top">
              <span> <i class="pi pi-id-card"></i></span>
              <h2 class="mb-0">
                Activity Log <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
              </h2>
            </span>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="col-lg-12 timeline-bar box-height">
            <div class="pt-3 pb-3">
              <div
                *ngIf="
                  !showSmallLoader && activityLogs.length > 0;
                  else noList
                ">
                <p-timeline [value]="activityLogs">
                  <ng-template pTemplate="content" let-activity>
                    <a>{{ activity.date | date: "medium" }}</a>
                    <h3>{{ activity.message }}</h3>
                    <h3>{{ activity.username }}</h3>
                  </ng-template>
                </p-timeline>
              </div>

              <ng-template #noList>
                <div class="col-lg-12 today-list-bar gray-bg">
                  <div
                    class="lds-ring inline me-auto ms-2"
                    *ngIf="showSmallLoader">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <p *ngIf="!showSmallLoader">No activity yet.</p>
                </div>
              </ng-template>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
</div>
